import {
  BeamQualityContainerDto,
  BeamShapingContainerDto,
  BeamShapingGroupCircularDto,
  BeamShapingGroupDto,
  BeamShapingGroupRectangularDto,
  CreatePhotonBeamQualityDoseRateValueListDto,
  CreateElectronBeamQualityDoseRateValueListDto,
  CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum,
  CreateElectronBeamQualityDoseRateValueListDtoTypeEnum,
  type CreateBeamQualityParameterContainerDto,
  CreateBeamQualityParameterContainerDtoTypeEnum,
  CreateBeamShapingContainerDto,
  CreateBeamShapingContainerDtoTypeEnum,
  CreateBeamShapingGroupCircularDto,
  CreateBeamShapingGroupCircularDtoTypeEnum,
  CreateBeamShapingGroupDto,
  CreateBeamShapingGroupRectangularDto,
  CreateBeamShapingGroupRectangularDtoTypeEnum,
  CreateDiscreteNumericListDto,
  CreateDiscreteNumericListDtoTypeEnum,
  CreateDiscreteNumericValueDto,
  CreateDiscreteNumericValueDtoTypeEnum,
  CreateEnumerationEvaluationOptionDto,
  CreateEnumerationEvaluationOptionDtoTypeEnum,
  CreateEnumerationEvaluationParameterDto,
  CreateEnumerationEvaluationParameterDtoTypeEnum,
  CreateEnumerationValueDto,
  CreateEnumerationValueDtoTypeEnum,
  CreateEnumerationValueListDto,
  CreateEnumerationValueListDtoTypeEnum,
  CreateEvaluationParameterDto,
  CreateEvaluationParameterScopeDto,
  CreateEvaluationParameterScopeDtoTypeEnum,
  CreateNumericDataSetFilterDtoTypeEnum,
  CreateNumericEvaluationParameterDto,
  CreateNumericEvaluationParameterDtoTypeEnum,
  CreateNumericListDto,
  CreateNumericListDtoTypeEnum,
  CreateNumericValueDto,
  CreateNumericValueDtoTypeEnum,
  CreateOrUpdateInstructionDto,
  CreateOrUpdateInstructionDtoTypeEnum,
  CreateOrUpdateMedicalSystemSetupBaseDto,
  CreateOrUpdateMedicalSystemSetupDto,
  CreateOrUpdateMedicalSystemSetupDtoTypeEnum,
  CreateOrUpdateMvTherapySystemSetupDto,
  CreateOrUpdateMvTherapySystemSetupDtoTypeEnum,
  CreateOrUpdateTaskItemAreaDataDto,
  CreateOrUpdateTaskItemAreaDataDtoTypeEnum,
  CreateOrUpdateTaskItemAreaDto,
  CreateOrUpdateTaskItemAreaDtoTypeEnum,
  CreateOrUpdateTaskItemDto,
  CreateOrUpdateTaskItemDtoTypeEnum,
  CreateParameterCombinationDto,
  CreateParameterCombinationDtoTypeEnum,
  CreateParameterCombinationTableDto,
  CreateParameterCombinationTableDtoTypeEnum,
  CreateTaskItemQaEquipmentSetupDto,
  CreateTaskItemQaEquipmentSetupDtoTypeEnum,
  CreateTextValueDto,
  CreateTextValueDtoTypeEnum,
  CreateTextValueListDto,
  CreateTextValueListDtoTypeEnum,
  CreateDiscreteTextValueListDto,
  CreateDiscreteTextValueListDtoTypeEnum,
  DiscreteNumericListDto,
  DiscreteNumericListDtoTypeEnum,
  DiscreteNumericValueDto,
  DiscreteNumericValueDtoTypeEnum,
  ElectronBeamQualityDoseRateValueListDto,
  EnumerationEvaluationOptionDto,
  EnumerationEvaluationParameterDto,
  EnumerationOptionDto,
  EnumerationValueDto,
  EnumerationValueDtoTypeEnum,
  EnumerationValueListDto,
  EnumerationValueListDtoTypeEnum,
  EvaluationParameterDto,
  EvaluationParameterScopeDto,
  ICreateSetupParameterFilter,
  ICreateSingleSystemSetupParameter,
  instanceOfBeamShapingGroupCircularDto,
  instanceOfBeamShapingGroupRectangularDto,
  instanceOfEnumerationEvaluationParameterDto,
  instanceOfNumericEvaluationParameterDto,
  InstructionDto,
  ISetupParameterFilter,
  ISingleSystemSetupParameter,
  MedicalSystemSetupBaseDto,
  MedicalSystemSetupDto,
  MvTherapySystemSetupDto,
  NumericDataSetFilterDtoTypeEnum,
  NumericEvaluationParameterDto,
  NumericListDto,
  NumericListDtoTypeEnum,
  NumericValueDto,
  ParameterCombinationDto,
  ParameterCombinationTableDto,
  PhotonBeamQualityDoseRateValueListDto,
  ReferencedEntityNullableLongDtoTypeEnum,
  TaskItemAreaDto,
  TaskItemDto,
  TaskItemQaEquipmentSetupDto,
  TextValueDto,
  TextValueDtoTypeEnum,
  TextValueListDto,
  TextValueListDtoTypeEnum,
  DiscreteTextValueListDto,
  DiscreteTextValueListDtoTypeEnum,
  TaskItemAreaDataDto,
} from '@/api/generator';
import { isNil, negate, pick } from 'lodash';
import { toReferencedEntityGuidDto } from '../quantities/mappings';
import { truthy } from '@/utils/helper.ts';

function toCreateEnumerationValueDto(dto: EnumerationValueDto): CreateEnumerationValueDto {
  return {
    ...dto,
    value: {
      id: dto.value?.id ?? null,
      $type:
        ReferencedEntityNullableLongDtoTypeEnum.PtwPtw100AppZeroApplicationSharedCommonDtoReferencedEntityNullableLongDtoPtwPtw100AppZeroApplicationShared,
    },
    $type:
      CreateEnumerationValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateEnumerationValueDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateNumericValueDto(dto: NumericValueDto): CreateNumericValueDto {
  return {
    ...dto,
    $type:
      CreateNumericValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateNumericValueDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateNumericListDto(dto: NumericListDto): CreateNumericListDto {
  return {
    ...dto,
    values: dto.values?.filter(negate(isNil)),
    $type:
      CreateNumericListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateNumericListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toReferencedEntityNullableLongDto(dto: EnumerationOptionDto) {
  return {
    ...pick(dto, ['id']),
    $type:
      ReferencedEntityNullableLongDtoTypeEnum.PtwPtw100AppZeroApplicationSharedCommonDtoReferencedEntityNullableLongDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateEnumerationValueListDto(
  dto: EnumerationValueListDto,
): CreateEnumerationValueListDto {
  return {
    ...pick(dto, [
      'dataTypeId',
      'setupParameterId',
      'groupId',
      'isRequired',
      'isReadonly',
      'isEnabled',
      'isUsedForEvaluation',
    ]),
    id: dto.id,
    selectedOptions: dto.selectedOptions?.map(toReferencedEntityNullableLongDto).filter(truthy),
    $type:
      CreateEnumerationValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoCreateEnumerationValueListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateDiscreteTextValueListDto(
  dto: DiscreteTextValueListDto,
): CreateDiscreteTextValueListDto {
  return {
    ...pick(dto, ['dataTypeId', 'selectedValues', 'isEnabled']),
    selectedValues: dto.selectedValues?.filter(negate(isNil)),
    $type:
      CreateDiscreteTextValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateDiscreteTextValueListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateDiscreteNumericListDto(dto: DiscreteNumericListDto): CreateDiscreteNumericListDto {
  return {
    ...dto,
    selectedValues: dto.selectedValues?.filter(negate(isNil)),
    $type:
      CreateDiscreteNumericListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDiscreteNumericListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateTextValueDto(dto: TextValueDto): CreateTextValueDto {
  return {
    ...dto,
    $type:
      CreateTextValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateTextValueDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateTextValueListDto(dto: TextValueListDto): CreateTextValueListDto {
  return {
    ...dto,
    values: dto.values?.filter(negate(isNil)),
    $type:
      CreateTextValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateTextValueListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateDiscreteNumericValueDto(
  dto: DiscreteNumericValueDto,
): CreateDiscreteNumericValueDto {
  return {
    ...dto,
    $type:
      CreateDiscreteNumericValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateDiscreteNumericValueDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toICreateSingleSystemSetupParameter(
  dto: ISingleSystemSetupParameter,
): ICreateSingleSystemSetupParameter {
  switch (dto.$type) {
    case EnumerationValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationValueDtoPtwPtw100AppZeroApplicationShared:
      return toCreateEnumerationValueDto(dto);
    case EnumerationValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationValueListDtoPtwPtw100AppZeroApplicationShared:
      return toCreateEnumerationValueListDto(dto);
    case NumericListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericListDtoPtwPtw100AppZeroApplicationShared:
      return toCreateNumericListDto(dto);
    case DiscreteNumericListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDiscreteNumericListDtoPtwPtw100AppZeroApplicationShared:
      return toCreateDiscreteNumericListDto(dto);
    case DiscreteNumericValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoDiscreteNumericValueDtoPtwPtw100AppZeroApplicationShared:
      return toCreateDiscreteNumericValueDto(dto);
    case TextValueDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueDtoPtwPtw100AppZeroApplicationShared:
      return toCreateTextValueDto(dto);
    case TextValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueListDtoPtwPtw100AppZeroApplicationShared:
      return toCreateTextValueListDto(dto);
    default:
      throw new Error(`Invalid $type hint "${dto.$type}" for "${typeof dto}"`);
  }
}

export function toICreateSetupParameterFilter(
  dto: ISetupParameterFilter,
): ICreateSetupParameterFilter {
  switch (dto.$type) {
    case NumericDataSetFilterDtoTypeEnum.PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataSetFilterDtoPtwPtw100AppZeroApplicationShared:
      return {
        ...dto,
        $type:
          CreateNumericDataSetFilterDtoTypeEnum.PtwPtw100AppZeroApplicationSharedResultsDtoCreateNumericDataSetFilterDtoPtwPtw100AppZeroApplicationShared,
      };

    case EnumerationValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationValueListDtoPtwPtw100AppZeroApplicationShared:
      return toCreateEnumerationValueListDto(dto);
    case DiscreteTextValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersDiscreteTextValueListDtoPtwPtw100AppZeroApplicationShared:
      return toCreateDiscreteTextValueListDto(dto);
    default:
      throw new Error(`Invalid $type hint "${dto.$type}" for "${typeof dto}"`);
  }
}

export function toCreateOrUpdateMedicalSystemSetupBaseDto(
  dto: MedicalSystemSetupBaseDto,
): CreateOrUpdateMedicalSystemSetupBaseDto {
  switch (dto.$type) {
    case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MedicalSystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
      return toCreateOrUpdateMedicalSystemSetupDto(dto);
    case 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.MvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared':
      return toCreateOrUpdateMvTherapySystemSetupDto(dto);
    default:
      throw new Error(`Invalid $type hint "${dto.$type}" for "${typeof dto}"`);
  }
}

function toCreateOrUpdateMedicalSystemSetupDto(
  dto: MedicalSystemSetupDto,
): CreateOrUpdateMedicalSystemSetupDto {
  return {
    ...dto,
    singleSetupParameters: dto.singleSetupParameters?.map(toICreateSingleSystemSetupParameter),
    $type:
      CreateOrUpdateMedicalSystemSetupDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateMedicalSystemSetupDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateBeamShapingGroupRectangularDto(
  dto: BeamShapingGroupRectangularDto,
): CreateBeamShapingGroupRectangularDto {
  return {
    ...dto,
    radiationFieldShape: dto.radiationFieldShape
      ? toCreateEnumerationValueDto(dto.radiationFieldShape)
      : undefined,
    radiationFieldSymmetry: dto.radiationFieldSymmetry
      ? toCreateEnumerationValueDto(dto.radiationFieldSymmetry)
      : undefined,
    radiationFieldSizeX: dto.radiationFieldSizeX
      ? toCreateNumericValueDto(dto.radiationFieldSizeX)
      : undefined,
    radiationFieldSizeY: dto.radiationFieldSizeY
      ? toCreateNumericValueDto(dto.radiationFieldSizeY)
      : undefined,
    radiationFieldEdgeX1: dto.radiationFieldEdgeX1
      ? toCreateNumericValueDto(dto.radiationFieldEdgeX1)
      : undefined,
    radiationFieldEdgeX2: dto.radiationFieldEdgeX2
      ? toCreateNumericValueDto(dto.radiationFieldEdgeX2)
      : undefined,
    radiationFieldEdgeY1: dto.radiationFieldEdgeY1
      ? toCreateNumericValueDto(dto.radiationFieldEdgeY1)
      : undefined,
    radiationFieldEdgeY2: dto.radiationFieldEdgeY2
      ? toCreateNumericValueDto(dto.radiationFieldEdgeY2)
      : undefined,
    $type:
      CreateBeamShapingGroupRectangularDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamShapingGroupRectangularDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateBeamShapingGroupCircularDto(
  dto: BeamShapingGroupCircularDto,
): CreateBeamShapingGroupCircularDto {
  return {
    ...dto,
    radiationFieldShape: dto.radiationFieldShape
      ? toCreateEnumerationValueDto(dto.radiationFieldShape)
      : undefined,
    radiationFieldSymmetry: dto.radiationFieldSymmetry
      ? toCreateEnumerationValueDto(dto.radiationFieldSymmetry)
      : undefined,
    radiationFieldSize: dto.radiationFieldSize
      ? toCreateNumericValueDto(dto.radiationFieldSize)
      : undefined,
    $type:
      CreateBeamShapingGroupCircularDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamShapingGroupCircularDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateBeamShapingGroupDto(dto: BeamShapingGroupDto): CreateBeamShapingGroupDto {
  if (instanceOfBeamShapingGroupRectangularDto(dto)) {
    return toCreateBeamShapingGroupRectangularDto(dto);
  } else if (instanceOfBeamShapingGroupCircularDto(dto)) {
    return toCreateBeamShapingGroupCircularDto(dto);
  } else {
    throw new Error(`Unsupported beam shaping type!`);
  }
}

function toCreateBeamShapingContainerDto(
  dto: BeamShapingContainerDto,
): CreateBeamShapingContainerDto {
  return {
    ...dto,
    selectedBeamShapings: dto.selectedBeamShapings?.map(toCreateBeamShapingGroupDto),
    $type:
      CreateBeamShapingContainerDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamShapingContainerDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreatePhotonBeamQualityDoseRateValueListDto(
  dto: PhotonBeamQualityDoseRateValueListDto,
): CreatePhotonBeamQualityDoseRateValueListDto {
  return {
    ...dto,
    radiationType: toCreateEnumerationValueDto(dto.radiationType),
    energy: toCreateNumericValueDto(dto.energy),
    primaryFluenceShaping: toCreateEnumerationValueDto(dto.primaryFluenceShaping),
    highDoseTechniqueType: toCreateEnumerationValueDto(dto.highDoseTechniqueType),
    selectedDoseRates: toCreateDiscreteNumericListDto(dto.selectedDoseRates),
    $type:
      CreatePhotonBeamQualityDoseRateValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreatePhotonBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateElectronBeamQualityDoseRateValueListDto(
  dto: ElectronBeamQualityDoseRateValueListDto,
): CreateElectronBeamQualityDoseRateValueListDto {
  return {
    ...dto,
    radiationType: toCreateEnumerationValueDto(dto.radiationType),
    energy: toCreateNumericValueDto(dto.energy),
    highDoseTechniqueType: toCreateEnumerationValueDto(dto.highDoseTechniqueType),
    selectedDoseRates: toCreateDiscreteNumericListDto(dto.selectedDoseRates),
    $type:
      CreateElectronBeamQualityDoseRateValueListDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateElectronBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateBeamQualityParameterContainerDto(
  dto: BeamQualityContainerDto,
): CreateBeamQualityParameterContainerDto {
  return {
    ...dto,
    beamQualitiesElectron: dto.beamQualitiesElectron?.map(
      toCreateElectronBeamQualityDoseRateValueListDto,
    ),
    beamQualitiesPhoton: dto.beamQualitiesPhoton?.map(
      toCreatePhotonBeamQualityDoseRateValueListDto,
    ),
    $type:
      CreateBeamQualityParameterContainerDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateBeamQualityParameterContainerDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateOrUpdateMvTherapySystemSetupDto(
  dto: MvTherapySystemSetupDto,
): CreateOrUpdateMvTherapySystemSetupDto {
  return {
    ...dto,
    beamShapingContainer: toCreateBeamShapingContainerDto(dto.beamShapingContainer),
    singleSetupParameters: dto.singleSetupParameters?.map(toICreateSingleSystemSetupParameter),
    beamQualityContainer: toCreateBeamQualityParameterContainerDto(dto.beamQualityContainer),
    $type:
      CreateOrUpdateMvTherapySystemSetupDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateMvTherapySystemSetupDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateOrUpdateTaskItemAreaDtoInstruction(
  dto: InstructionDto,
): CreateOrUpdateInstructionDto {
  return {
    ...dto,
    $type:
      CreateOrUpdateInstructionDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateInstructionDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateTaskItemQaEuipmentSetupDto(
  dto: TaskItemQaEquipmentSetupDto,
): CreateTaskItemQaEquipmentSetupDto {
  return {
    ...dto,
    singleSetupParameters: dto.singleSetupParameters?.map(toICreateSingleSystemSetupParameter),
    $type:
      CreateTaskItemQaEquipmentSetupDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateTaskItemQaEquipmentSetupDtoPtwPtw100AppZeroApplicationShared,
  };
}

// 01 EnumerationEvaluationParameterDto
function toCreateEnumerationEvaluationParameterDto(
  dto: EnumerationEvaluationParameterDto,
): CreateEnumerationEvaluationParameterDto {
  return {
    ...dto,
    options: dto.options?.map((option) => toCreateEnumerationEvaluationOptionDto(option)),
    $type:
      CreateEnumerationEvaluationParameterDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateEnumerationEvaluationParameterDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateEnumerationEvaluationOptionDto(
  dto: EnumerationEvaluationOptionDto,
): CreateEnumerationEvaluationOptionDto {
  return {
    ...dto,

    $type:
      CreateEnumerationEvaluationOptionDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateEnumerationEvaluationOptionDtoPtwPtw100AppZeroApplicationShared,
  };
}

// 02 NumericEvaluationParameterDto
function toCreateNumericEvaluationParameterDto(
  dto: NumericEvaluationParameterDto,
): CreateNumericEvaluationParameterDto {
  return {
    ...dto,
    definition: dto.definition ? toReferencedEntityGuidDto(dto.definition) : undefined,
    definitionParameterValueSet: dto.definitionParameterValueSet
      ? toReferencedEntityGuidDto(dto.definitionParameterValueSet)
      : undefined,
    $type:
      CreateNumericEvaluationParameterDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateNumericEvaluationParameterDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateEvaluationParameterScopeDto(
  dto: EvaluationParameterScopeDto,
): CreateEvaluationParameterScopeDto {
  return {
    ...dto,
    evaluationParameters: dto.evaluationParameters?.map((item) =>
      toCreateEvaluationParameterDto(item),
    ),
    $type:
      CreateEvaluationParameterScopeDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateEvaluationParameterScopeDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateOrUpdateTaskItemAreaDataDto(
  _dto: TaskItemAreaDataDto,
): CreateOrUpdateTaskItemAreaDataDto {
  return {
    $type:
      CreateOrUpdateTaskItemAreaDataDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateTaskItemAreaDataDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateEvaluationParameterDto(
  dto: EvaluationParameterDto,
): CreateEvaluationParameterDto {
  if (instanceOfEnumerationEvaluationParameterDto(dto)) {
    return toCreateEnumerationEvaluationParameterDto(dto);
  } else if (instanceOfNumericEvaluationParameterDto(dto)) {
    return toCreateNumericEvaluationParameterDto(dto);
  } else {
    throw new Error(`Unsupported EvaluationParameterDto`);
  }
}

export function toCreateOrUpdateTaskItemAreaDto(
  dto: TaskItemAreaDto,
): CreateOrUpdateTaskItemAreaDto {
  return {
    ...dto,
    medicalSystemSetup: dto.medicalSystemSetup
      ? toCreateOrUpdateMedicalSystemSetupBaseDto(dto.medicalSystemSetup)
      : undefined,
    qaEquipmentSetups: dto.qaEquipmentSetups?.map(toCreateTaskItemQaEuipmentSetupDto),
    instruction: dto.instruction
      ? toCreateOrUpdateTaskItemAreaDtoInstruction(dto.instruction)
      : undefined,
    evaluationScopes: dto.evaluationScopes?.filter(truthy).map(toCreateEvaluationParameterScopeDto),
    combinationTable: dto.combinationTable
      ? toCreateParameterCombinationTableDto(dto.combinationTable)
      : undefined,
    taskTypeData: dto.taskTypeData
      ? toCreateOrUpdateTaskItemAreaDataDto(dto.taskTypeData)
      : undefined,
    $type:
      CreateOrUpdateTaskItemAreaDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateTaskItemAreaDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateParameterCombinationTableDto(
  dto: ParameterCombinationTableDto,
): CreateParameterCombinationTableDto {
  return {
    ...dto,
    combinations: dto.combinations?.map((item) => toCreateParameterCombinationDto(item)),
    $type:
      CreateParameterCombinationTableDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsCreateParameterCombinationTableDtoPtwPtw100AppZeroApplicationShared,
  };
}

function toCreateParameterCombinationDto(
  dto: ParameterCombinationDto,
): CreateParameterCombinationDto {
  return {
    ...dto,
    $type:
      CreateParameterCombinationDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsCreateParameterCombinationDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function toCreateOrUpdateTaskItemDto(dto: TaskItemDto): CreateOrUpdateTaskItemDto {
  return {
    ...dto,
    taskItemAreas: dto.taskItemAreas?.map(toCreateOrUpdateTaskItemAreaDto),
    $type:
      CreateOrUpdateTaskItemDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateTaskItemDtoPtwPtw100AppZeroApplicationShared,
  };
}
